export const GET_INTERACTORS = "GET_INTERACTORS";
export const GET_INTERACTOR_BY_ID = "GET_INTERACTOR_BY_ID";
export const UPDATE_INTERACTOR = "UPDATE_INTERACTOR";
export const DELETE_INTERACTOR = "DELETE_INTERACTOR";
export const CREATE_INTERACTOR = "CREATE_INTERACTOR";
